import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NavigationEnd, Router } from "@angular/router";
import { PwaInstallService } from "@/app/core/services/pwa-install.service";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-pwa-install-banner",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./pwa-install-banner.component.html",
})
export class PwaInstallBannerComponent implements OnInit, OnDestroy {
  private pwaInstall = inject(PwaInstallService);
  private router = inject(Router);
  private sub = new Subscription();

  show = false;

  get isIos(): boolean {
    return this.pwaInstall.isIos();
  }

  private updateShow(): void {
    if (this.pwaInstall.isBannerSuppressedForUrl(this.router.url)) {
      this.show = false;
      return;
    }
    this.show = this.pwaInstall.canShowBanner || this.pwaInstall.canShowIosBanner;
  }

  ngOnInit(): void {
    this.sub.add(
      this.router.events.pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd)).subscribe(() => this.updateShow()),
    );
    this.sub.add(this.pwaInstall.canInstall$.subscribe(() => this.updateShow()));
    this.updateShow();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  async install(): Promise<void> {
    await this.pwaInstall.promptInstall();
    this.show = false;
  }

  dismiss(): void {
    this.pwaInstall.dismissBanner();
    this.show = false;
  }
}
